import { HStack } from "@chakra-ui/react"
import { InfoCircleIcon } from "@pathwright/pathicons"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import RoleDescriptorsDrawer from "../shared/RoleDescriptorsDrawer"

const SelectRoleDescriptorsDrawerOption = ({ children }) => {
  const { tc } = useTranslate()

  return (
    <RoleDescriptorsDrawer>
      {({ ref, onOpen }) => {
        const option = {
          label: tc(`share_card.add_tab.Learn more`),
          value: "__drawer_option_learn_more",
          render: (node) => (
            <HStack ref={ref} color="gray.500">
              <InfoCircleIcon size={"1.2em"} />
              {node}
            </HStack>
          )
        }

        return children({
          option,
          onOpen
        })
      }}
    </RoleDescriptorsDrawer>
  )
}

export default SelectRoleDescriptorsDrawerOption
